import { TextComponent } from './text/text.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { SelectComponent } from './select/select.component';
import { DateDurationComponent } from './date-duration/date-duration.component';
import { UploadComponent } from './upload/upload.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { AadharComponent } from './aadhar/aadhar.component';
// import { TableComponent } from './table/table.component';
import { TableTwoComponent } from './table-two/table-two.component';
import { DGeoLocationComponent } from './d-geo-location/d-geo-location.component';
import { RadioComponent } from './radio/radio.component';
import { MultiTabTableComponent } from './multi-tab-table/multi-tab-table.component';
import { SimpleTextComponent } from './simple-text/simple-text.component';
export {
	TextComponent,
	CheckboxComponent,
	SelectComponent,
	DateDurationComponent,
	UploadComponent,
	InputGroupComponent,
	AadharComponent,
	// TableComponent,
	TableTwoComponent,
	DGeoLocationComponent,
	RadioComponent,
	MultiTabTableComponent,
	SimpleTextComponent
};
